import Cookies from "js-cookie";

const ULogin = (data) => {

    Cookies.set("cst", data.access_token, {expires: 2});
    Cookies.set("ut", data?.stamp, {expires: 2});
    
};
export default ULogin